import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { UserService } from 'src/app/core/services/user.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { User } from '../../model/user.model';
import {} from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

@Component({
  standalone: true,
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    I18NextModule,
    MatDialogModule,

    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    HttpClientModule
  ]
})
export class FeedbackModalComponent implements OnInit {
  @Input() dato: any | null = null;

  @Output() confirmCancelOrderEmitter = new EventEmitter<boolean>();

  spinner = false;
  landing2 = false;
  constructor(
    public dialogRef: MatDialogRef<FeedbackModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      text: string;
      redirect?: boolean;
      list?: boolean;
      cancelOrder?: boolean;
      close?: boolean;
      manageData?: boolean;
      theme: string;
    },
    private router: Router,
    private storageService: StorageService,
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
  }

  onListRedirect() {
    this.spinner = true;
    setTimeout(() => {
      this.dialogRef.close();
    }, 4000);
    this.dialogRef.afterClosed().subscribe(() => {
      if (this.landing2) this.router.navigateByUrl('landing-leasing');
      else this.router.navigateByUrl('list-requests');
    });
  }

  onListRedirectUpdateUser() {
    let user: User;
    this.userService.getUser().subscribe({
      next: (resp: User) => {
        user = {
          ...resp
        };
        this.storageService.set('config', user);
      }
    });
    this.spinner = true;
    setTimeout(() => {
      this.dialogRef.close();
    }, 4000);
    this.dialogRef.afterClosed().subscribe(() => {
      if (user.groupType === 'EXTERNVO') {
        this.router.navigateByUrl('vo');
      } else if (this.landing2) {
        this.router.navigateByUrl('landing-leasing');
      } else {
        this.router.navigateByUrl('list-requests');
      }
    });
  }

  confirmCancel() {
    this.dialogRef.close();
    this.confirmCancelOrderEmitter.emit(true);
  }

  getSafeHtml(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
